// extracted by mini-css-extract-plugin
export default {"header":"brandCatalogue_header__U-l1J"};